import type { RouteRecordRaw } from 'vue-router';

export const organizationsRoute: RouteRecordRaw = {
  path: '/settings/organizations',
  name: 'Organizations',
  component: () => import('./pages/OrganizationsPage.vue'),
  meta: {
    layout: 'main',
    // Gated on `create`, matching the nav item, because this page is the
    // organization *editor*. `organizations:list` is a dictionary read every
    // signed-in account carries — it is what puts a name on a badge, and it is
    // not permission to open the administration screen behind it.
    authorize: ({ isGranted }) => isGranted('st:core:organizations:create'),
  },
};
